import { Merge } from 'type-fest/index.d';

import { experimentsReducer } from '@hh.ru/front-static-app';
import { BaseRootState } from '@hh.ru/front-static-app/lib/browserApp/modules/baseReducer';
import { autoGeneratedReducer, ReducerObject } from '@hh.ru/redux-create-reducer';

import { DefaultPageMetaData, PageMetaData } from 'src/models/pageMetaData';
import { AdminArticleState } from 'src/models/pages/adminArticle';
import { AdminArticlesCatalogState } from 'src/models/pages/adminArticlesCatalog';
import { AdminCollectionEdProgramCatalogState } from 'src/models/pages/adminCollectionEdProgramCatalog';
import { AdminCourseState } from 'src/models/pages/adminCourse';
import { AdminCoursesCatalogState } from 'src/models/pages/adminCoursesCatalog';
import { AdminEducationState } from 'src/models/pages/adminEducation';
import { AdminEducationsCatalogState } from 'src/models/pages/adminEducationsCatalog';
import { AdminProfessionState } from 'src/models/pages/adminProfession';
import { AdminProfessionsCatalogState } from 'src/models/pages/adminProfessionsCatalog';
import { AdminPromotionsCatalogState } from 'src/models/pages/adminPromotionsCatalog';
import { AdminProvidersCatalogState } from 'src/models/pages/adminProvidersCatalog';
import { AdminProvidersStreamWeightState } from 'src/models/pages/adminProvidersStreamWeight';
import { AdminStreamState } from 'src/models/pages/adminStream';
import { AdminStreamsCatalogState } from 'src/models/pages/adminStreamsCatalog';
import { ArticleState } from 'src/models/pages/article';
import { ArticlesCatalogState } from 'src/models/pages/articlesCatalog';
import { CertPageState } from 'src/models/pages/cert';
import { PageCollectionEdProgramState } from 'src/models/pages/collectionEdProgram';
import { PageEdProgramCatalogState } from 'src/models/pages/edPrograms';
import { Landing } from 'src/models/pages/landing';
import { PageLKState } from 'src/models/pages/lk';
import { ProfessionInitialState } from 'src/models/pages/profession';
import { Professions } from 'src/models/pages/professions';
import profileReducer from 'src/models/profile';
import { UserAreaState } from 'src/models/userArea';
import USER_TYPES from 'src/models/userTypes';
import { CareerTrackState } from 'src/models/widgets/careerTrack';
import { CollectionEdProgramGroupsState } from 'src/models/widgets/collectionEdProgramGroups';
import { MentorsState } from 'src/models/widgets/mentors';

const appReducer = {
    pageMetaData: autoGeneratedReducer<PageMetaData>(DefaultPageMetaData),
    profile: profileReducer,
    userId: autoGeneratedReducer<string>(null),
    userType: autoGeneratedReducer<USER_TYPES>(USER_TYPES.ANONYMOUS),
    userArea: autoGeneratedReducer<UserAreaState>(null),
    experiments: experimentsReducer,
    // pages
    landing: autoGeneratedReducer<Landing>(null),
    pageLK: autoGeneratedReducer<PageLKState>(null),
    pageProfession: autoGeneratedReducer<ProfessionInitialState>(null),
    pageProfessions: autoGeneratedReducer<Professions>(null),
    pageEdProgramsCatalog: autoGeneratedReducer<PageEdProgramCatalogState>(null),
    pageCollectionEdProgram: autoGeneratedReducer<PageCollectionEdProgramState>(null),
    pageCert: autoGeneratedReducer<CertPageState>(null),
    pageArticle: autoGeneratedReducer<ArticleState>(null),
    pageArticlesCatalog: autoGeneratedReducer<ArticlesCatalogState>(null),
    // widgets
    widgetMentors: autoGeneratedReducer<MentorsState>(null),
    widgetCareerTrack: autoGeneratedReducer<CareerTrackState>(null),
    widgetCollectionEdProgramGroups: autoGeneratedReducer<CollectionEdProgramGroupsState>(null),
    // admin
    pageAdminCourse: autoGeneratedReducer<AdminCourseState>(null),
    pageAdminEducationsCatalog: autoGeneratedReducer<AdminEducationsCatalogState>(null),
    pageAdminEducation: autoGeneratedReducer<AdminEducationState>(null),
    pageAdminCoursesCatalog: autoGeneratedReducer<AdminCoursesCatalogState>(null),
    pageAdminStreamsCatalog: autoGeneratedReducer<AdminStreamsCatalogState>(null),
    pageAdminStream: autoGeneratedReducer<AdminStreamState>(null),
    pageAdminProfessionsCatalog: autoGeneratedReducer<AdminProfessionsCatalogState>(null),
    pageAdminProfession: autoGeneratedReducer<AdminProfessionState>(null),
    pageAdminProvidersCatalog: autoGeneratedReducer<AdminProvidersCatalogState>(null),
    pageAdminPromotionsCatalog: autoGeneratedReducer<AdminPromotionsCatalogState>(null),
    pageAdminArticlesCatalog: autoGeneratedReducer<AdminArticlesCatalogState>(null),
    pageAdminArticle: autoGeneratedReducer<AdminArticleState>(null),
    pageAdminCollectionEdProgramsCatalog: autoGeneratedReducer<AdminCollectionEdProgramCatalogState>(null),
    pageAdminProvidersStreamWeight: autoGeneratedReducer<AdminProvidersStreamWeightState>(null),
};

export default appReducer;

type Store<R = typeof appReducer> = { [K in keyof R]: R[K] extends ReducerObject<infer D, unknown> ? D : never };
type FullRootState = Merge<Store, BaseRootState>;

declare module 'react-redux' {
    /* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
    export interface DefaultRootState extends FullRootState {}
}
